<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div class="mt-2">
      <b-row>
        <b-col lg="4">
          <b-card>
            <div slot="header">
              <strong>Pricing Rule</strong> &nbsp;&nbsp;
              <div class="pull-right">
                <button class="btn btn-warning" @click="$router.go(-1)"><i title="Back" class="fa fa-arrow-left fa-lg text-white"></i> <strong class="text-white">Return to Rules</strong></button>
                <button class="btn btn-info" @click="saveAndRedirect"><i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong></button>
              </div>
            </div>
            <b-row>
              <b-col lg="12">
                <b-form-group>
                  <label for="name">Rule Name</label>
                  <b-form-input type="text" v-model="policy.Name" placeholder="Policy name"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <b-alert variant="warning" class="text-center" show><strong>Note: </strong>Rate mark-up does not affect profit type scans.</b-alert>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="8">
          <b-card>
            <div slot="header">
              <strong>Scan</strong> <small>Options</small>
            </div>
            <b-row>
              <b-col lg="2">
                <label>Scan Type</label>
                <b-form-select :options="[{text:'Profit',value:0},{text:'Selling Price', value:1}]" v-model="policy.ScanType" @change="onScanTypeChange">
                </b-form-select>
              </b-col>
              <b-col lg="2">
                <label>Adjustment Type</label>
                <b-form-radio-group v-if="policy.ScanType === 0" v-model="policy.Profit.Type" stacked
                                    :options="[
                      {text: 'MSRP',value: 0},
                      {text: 'Cost',value: 1},
                      {text: 'Dollar Value $',value: 2}
                      ]">
                </b-form-radio-group>
                <b-form-radio-group v-else v-model="policy.SellingPrice.Type" stacked
                                    :options="[
                    {text: 'Sticker Price',value: 0},
                    {text: 'GSM Price',value: 1},
                    {text: 'Preferred Price',value: 2},
                    {text: 'MSRP',value: 3},
                    {text: 'Cost',value: 4},
                    ]">
                </b-form-radio-group>
              </b-col>
              <slot v-if="policy.ScanType === 0">
                <b-col lg="2">
                  <label>Adjustment Flat value</label>
                  <b-input-group>
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-dollar"></i>&nbsp; &#177;</b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" v-model="policy.Profit.FlatAmount"></b-form-input>
                  </b-input-group>
                </b-col>
              </slot>
              <slot v-if="policy.ScanType === 1">
                <b-col lg="2">
                  <label>Adjustment Flat value</label>
                  <b-input-group>
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-dollar"></i>&nbsp; &#177;</b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" v-model="policy.SellingPrice.FlatAmount"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="2" v-if="policy.SellingPrice.Type > 2">
                  <label>Adjustment Percentage</label>
                  <b-input-group>
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-percent"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" v-model="policy.SellingPrice.Value"></b-form-input>
                  </b-input-group>
                </b-col>
              </slot>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-card>
            <div slot="header">
              <strong>Vehicles</strong>
              <button class="btn btn-success" @click="createNewRule()" style="margin-left:10px;"><i title="Add a new vehicle rule" class="fa fa-plus-square"></i></button>
            </div>
            <b-row>
              <b-col lg="12">
                <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                  <thead class="thead-light">
                    <tr>
                      <th aria-colindex="1">Type</th>
                      <th aria-colindex="2">Year</th>
                      <th aria-colindex="3">Make</th>
                      <th aria-colindex="4">Model</th>
                      <th aria-colindex="5">Trim</th>
                      <th aria-colindex="6"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(vr, i) in policy.vehiclerules">
                      <td>
                        <b-form-select :options="[{text:'New',value:1},{text:'Used', value:0}]" v-model="vr.newused" @changed="onRuleVehicleTypeChanged(vr, $event)"></b-form-select>
                      </td>
                      <td>
                        <b-form-select v-model="vr.year" @change="onRuleYearChanged(vr, $event)" required>
                          <slot v-if="vr.newused === 1">
                            <option v-for="o in policy.list_year_new" :value="o.id">{{ o.name }}</option>
                          </slot>
                          <slot v-else>
                            <option v-for="o in policy.list_year_used" :value="o.id">{{ o.name }}</option>
                          </slot>
                        </b-form-select>
                      </td>
                      <td>
                        <b-form-select v-model="vr.make" @change="onRuleMakeChanged(vr, $event)" required>
                          <option v-for="o in vr.make_list" :value="o.id">{{ o.name }}</option>
                        </b-form-select>
                      </td>
                      <td>
                        <b-form-select v-model="vr.model" @change="onRuleModelChanged(vr, $event)" required>
                          <option v-for="o in vr.model_list" :value="o.id">{{ o.name }}</option>
                        </b-form-select>
                      </td>
                      <td>
                        <b-form-select v-model="vr.trim" required>
                          <option v-for="o in vr.trim_list" :value="o.id">{{ o.name }}</option>
                        </b-form-select>
                      </td>
                      <td>
                        <button class="btn btn-danger text-white" @click="deleteRule(i)">
                          <i class="fa fa-trash-o fa-lg" title="Delete"></i>
                        </button>
                        <button class="btn btn-info text-white" @click="copyToNewRule(vr)">
                          <i class="fa fa-copy fa-lg" title="Copy"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'

export default {
  components: {
    loading
  },
  created () {
    if (this.$route.params.policyId < 0) {
      axios.all([
        axios.get('/api/quotepolicy/getyears?isnew=1&year=0&make=0&model=0'),
        axios.get('/api/quotepolicy/getyears?isnew=0&year=0&make=0&model=0'),
        axios.get('/api/quotepolicy/getmakes?isnew=1&year=&make=0&model=0'),
        axios.get('/api/quotepolicy/getmakes?isnew=0&year=&make=0&model=0')
      ])
        .then(axios.spread((newYearsRes, usedYearsRes, newMakesRes, usedMakesRes) => {
          this.policy.list_year_new = newYearsRes.data
          this.policy.list_year_used = usedYearsRes.data
          this.policy.list_makes_new = newMakesRes.data
          this.policy.list_makes_used = usedMakesRes.data
          this.boolLoading = false
        }))
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })

      if (!this.policy.PartnerIDInt) {
        this.policy.PartnerIDInt = window.localStorage.getItem('addquotingpolicy_partneridint')
        this.partnerName = window.localStorage.getItem('addquotingpolicy_partner')
        window.localStorage.removeItem('addquotingpolicy_partneridint')
        window.localStorage.removeItem('addquotingpolicy_partner')
      }
      return
    }

    axios.all([
      axios.get('/api/quotepolicy/load?id=' + this.$route.params.policyId),
      axios.get('/api/quotepolicy/getmakes?isnew=1&year=&make=0&model=0'),
      axios.get('/api/quotepolicy/getmakes?isnew=0&year=&make=0&model=0')
    ])
      .then(axios.spread((policyRes, newMakesRes, usedMakesRes) => {
        this.policy = policyRes.data.data
        this.partnerName = policyRes.data.partner
        this.policy.list_makes_new = newMakesRes.data
        this.policy.list_makes_used = usedMakesRes.data
        this.boolLoading = false
      }))
      .catch(error => {
        if (error.response.status == 403) { this.$router.push('/login') }

        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      partnerName: '',
      policy: {
        'ID': -1,
        'PartnerIDInt': 0,
        'Name': '',
        'ScanType': 1,
        'SellingPrice': {
          'FlatAmount': 0,
          'Value': 0,
          'Type': 4
        },
        'Profit': null,
        'vehiclerules': [],
        'list_year_new': [
          {
            'id': '0',
            'name': 'Any'
          }
        ],
        'list_year_used': [
          {
            'id': '0',
            'name': 'Any'
          }
        ]
      }
    }
  },
  methods: {
    createNewRule () {
      var newRule = {
        id: this.policy.vehiclerules.length ? this.policy.vehiclerules[this.policy.vehiclerules.length - 1].id + 1 : 1,
        newused: 1,
        year: 0,
        make: 0,
        make_list: this.policy.list_makes_new,
        model: 0,
        trim: 0,
        lotagefrom: null,
        lotageto: null,
        model_list: [{ id: '0', name: 'Any' }],
        trim_list: [{ id: '0', name: 'Any' }]
      }
      this.policy.vehiclerules.push(newRule)
    },
    copyToNewRule (rule) {
      var newRule = JSON.parse(JSON.stringify(rule))
      newRule.id = this.policy.vehiclerules[this.policy.vehiclerules.length - 1].id + 1
      this.policy.vehiclerules.push(newRule)
    },
    saveAndNew () {
      if (this.savePolicy()) { this.$router.push('/QuotePolicyDetail/-1') }
    },
    saveAndRedirect () {
      if (this.savePolicy()) { this.$router.push('/quotepolicies') }
    },
    savePolicy () {
      if (!this.policy.Name || this.policy.Name == '') {
        this.errMsg = 'Name cannot be blank.'
        this.showDismissibleAlert = true
        return false
      }

      if (!this.policy.vehiclerules.length) {
        this.errMsg = 'You must add a vehicle rule.'
        this.showDismissibleAlert = true
        return false
      }

      this.boolLoading = true
      var obj = {}
      obj.data = this.policy
      obj.id = this.policy.ID
      obj.name = this.policy.Name
      obj.partneridint = this.policy.PartnerIDInt
      obj.err = ''

      axios({
        method: this.policy.ID > 0 ? 'put' : 'post',
        url: '/api/quotepolicy/save',
        data: obj
      })
        .then(response => {
          this.policy.ID = response.data.id
          window.history.replaceState({}, null, '/#/QuotePolicyDetail/' + response.data.id)
          if (response.data.err.length > 0) {
            this.errMsg = response.data.err
          } else {
            this.errMsg = 'Quoting rule changes will not be reflected in mDrive search results until the following day.'
            this.dismissibleType = 'success'
          }

          this.showDismissibleAlert = true

          this.boolLoading = false
          return true
        })
        .catch(error => {
          if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { this.$router.push('/login') }

          console.log(error)
          this.boolLoading = false
          this.errMsg = 'There was an error saving data : ' + error
          this.showDismissibleAlert = true

          if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { this.errMsg = error.response.statusText.replace('403.1', '') }
          return false
        })
    },
    onScanTypeChange (value) {
      if (value === 0) {
        if (this.policy.Profit === null) { this.policy.Profit = { Type: 2, Value: '', FlatAmount: '' } }
      } else {
        if (this.policy.SellingPrice === null) { this.policy.SellingPrice = { Type: 3, Value: '', FlatAmount: '' } }
      }
    },
    onRuleVehicleTypeChanged (rule, arg) {
      if (arg === '1') { rule.make_list = this.policy.list_makes_new } else { rule.make_list = this.policy.list_makes_used }
      rule.year = 0
      rule.make = 0
      rule.model = 0
      rule.trim = 0
    },
    onRuleYearChanged (rule, arg) {
      rule.make = 0
      rule.model = 0
      rule.trim = 0
      this.boolLoading = true
      axios.get('/api/quotepolicy/getmakes?isnew=' + rule.newused + '&year=' + (arg === '0' ? '' : arg) + '&make=' + rule.make + '&model=' + rule.model)
        .then(response => {
          rule.make_list = response.data
          this.boolLoading = false
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    onRuleMakeChanged (rule, arg) {
      rule.model = 0
      rule.trim = 0
      this.boolLoading = true
      axios.get('/api/quotepolicy/getmodels?isnew=' + rule.newused + '&year=' + rule.year + '&make=' + arg + '&model=' + rule.model)
        .then(response => {
          rule.model_list = response.data
          this.boolLoading = false
        })
        .catch(error => {
        })
    },
    onRuleModelChanged (rule, arg) {
      rule.trim = 0
      this.boolLoading = true
      axios.get('/api/quotepolicy/gettrims?isnew=' + rule.newused + '&year=' + rule.year + '&make=' + rule.make + '&model=' + arg)
        .then(response => {
          rule.trim_list = response.data
          this.boolLoading = false
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    deleteRule (ruleIndex) {
      Vue.delete(this.policy.vehiclerules, ruleIndex)
    },
    nullOnEmpty (value, event) {
      if (value == '0') return value

      return value == '' ? null : value
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    if (this.$route.params.policyId > 0) { this.boolLoading = true }
  }
}
</script>

<style>
  .table-features > tbody > tr > td,
  .table-features > tbody > tr > th {
    border: 0;
    background-color: white;
    padding: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/views/mGuagePricingRuleDetail.vue